
const ELLEVIO_ERROR_TIMEOUT = 'ELLEVIO_ERROR_TIMEOUT';
const ELLEVIO_ERROR_4XX5XX = 'ELLEVIO_ERROR_4XX5XX';

export default {
    ELLEVIO_ERROR_TIMEOUT,
    ELLEVIO_ERROR_4XX5XX
}
